import { BaseDataModel } from "@domain/BaseDataModel";

export class JobReady extends BaseDataModel {
	name!: string;
	jobIds!: string[];
	submissionNotes!: string;
	priority!: string;
	submitter!: string;
}
